import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getCurrentSession, setCurrentSession } from "../actions/account";
import { getModulesFormatted } from "../actions/modules";
import { refreshTokensIfNeeded } from "../boot/auth";
import StartupState from "./StartupState";

function AuthLoader({ children, getCurrentSession, getModulesFormatted, setCurrentSession }) {
  const [status, setStatus] = useState("loading");
  const [attempt, setAttempt] = useState(0);

  const retry = () => {
    setStatus("loading");
    setAttempt((value) => value + 1);
  };

  useEffect(() => {
    (async () => {
      try {
        const tokens = await refreshTokensIfNeeded();
        if (!tokens) {
          setCurrentSession(null);
          setStatus("ready");
          return;
        }
        await getCurrentSession();
        await getModulesFormatted();
      } catch (err) {
        if (err.authInvalid) {
          setStatus("ready");
          return;
        }
        // Let route guards handle unauthenticated, non-admin and locked users.
        if (err.response && [401, 403, 428].includes(err.response.status)) {
          setStatus("ready");
          return;
        }
        console.error(err);
        setStatus("error");
        return;
      }

      setStatus("ready");
    })();
  }, [attempt]);

  if (status === "error") {
    return (
      <StartupState
        error="Impossible de terminer le chargement. Vérifiez votre connexion et réessayez."
        onRetry={retry}
      />
    );
  }

  if (status === "loading") {
    return <StartupState />;
  }

  return children;
}

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ getCurrentSession, getModulesFormatted, setCurrentSession }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthLoader);
